import { MdOutlineModeOfTravel, MdPersonPin, MdCategory, MdNotifications, MdSettings, MdPayment, MdBugReport, MdOutlineHotel } from "react-icons/md";
import { BiAbacus, BiUser } from "react-icons/bi";
import { AiOutlineBug, AiOutlineCalendar, AiOutlineBarChart } from "react-icons/ai";
import { BsListCheck } from "react-icons/bs";
import { FaRegNewspaper } from "react-icons/fa6";
import { PiUserGearLight, PiFlagBanner } from "react-icons/pi";
import { LuLayoutDashboard } from "react-icons/lu";
import { GiNewspaper } from "react-icons/gi";
import { TbCategoryPlus } from "react-icons/tb";
import { CgShoppingCart } from "react-icons/cg";

import { FaStar } from "react-icons/fa";
import { MdVerifiedUser, MdChat, MdAccountBalance, MdStar, MdBlock } from "react-icons/md";

export const RouteName = [
    {
        path: "/",
        name: "Dashboard",
        icon: <LuLayoutDashboard color="#768191" />,
    },
    {
        name: "Astrologer",
        icon: <BiUser color="#768191" />,
        subRoutes: [
            {
                path: "/astrologer",
                name: " List Of Astrologers",
                icon: <BiUser color="#768191" />,
            },
            {
                path: "/astrologer-enquiry",
                name: "Astrologer Enquiry",
                icon: <BiUser color="#768191" />,
            },
            {
                path: "/withdrawal-request",
                name: "Withdrawal Request",
                icon: <BiUser color="#768191" />,
            },
            {
                path: "/astrologer-manage",
                name: "Manage Astrologers",
                icon: <BiUser color="#768191" />,
            },
        ],
    },
    {
        path: "/user",
        hidden: true,
        name: "User",
        icon: <BiUser color="#768191" />,

    },
    {
        path: "/new-users",
        name: "New Users",
        icon: <BiUser color="#768191" />,
    },
    {
        path: "/notifications",
        name: "Notifications",
        icon: <MdNotifications color="#768191" />,
    },
    {
        path: "/app-config",
        name: "App Config",
        icon: <MdSettings color="#768191" />,
    },
    {
        path: "/payment-gateways",
        name: "Payment Gateways",
        icon: <MdPayment color="#768191" />,
    },
    {
        path: "/utilities",
        name: "Utilities",
        icon: <BiAbacus color="#768191" />,
    },

    {
        name: "Astro Mall",
        icon: <PiUserGearLight color="#768191" />,
        subRoutes: [
            {
                path: "/astro-mall/category",
                name: "Category",
                icon: <AiOutlineBug color="#768191" />,
            },
            {
                path: "/astro-mall/product",
                name: "Product",
                icon: <AiOutlineBug color="#768191" />,
            },
            {
                path: "/astro-mall/order-history",
                name: "Order History",
                icon: <AiOutlineBug color="#768191" />,
            },
        ],
    },
    {
        name: "Astro Puja",
        icon: <PiUserGearLight color="#768191" />,
        subRoutes: [
            {
                path: "/astro-puja/puja",
                name: "Puja",
                icon: <AiOutlineBug color="#768191" />,
            },
            {
                path: "/astro-puja/puja-request",
                name: "Puja Request",
                icon: <AiOutlineBug color="#768191" />,
            },
            {
                path: "/astro-puja/puja-booked",
                name: "Puja Booked",
                icon: <AiOutlineBug color="#768191" />,
            },
            {
                path: "/astro-puja/puja-history",
                name: "Puja History",
                icon: <AiOutlineBug color="#768191" />,
            },
        ],
    },
    {
        path: "/history",
        name: "History",
        icon: <BiUser color="#768191" />,
        subRoutes: [
            {
                path: "/history/chat-history",
                name: "Chat History",
                icon: <BiUser color="#768191" />,
            },
            {
                path: "/history/call-history",
                name: "Call History",
                icon: <BiUser color="#768191" />,
            },
            {
                path: "/history/video-call-history",
                name: "V.Call History",
                icon: <BiUser color="#768191" />,
            },
            {
                path: "/history/live-history",
                name: "Live History",
                icon: <BiUser color="#768191" />,
            },
            {
                path: "/history/gift-history",
                name: "Gift History",
                icon: <BiUser color="#768191" />,
            },
        ],
    },
    {
        path: "/rechargeHistory",
        name: "Services History",
        icon: <BiUser color="#768191" />,
        hidden: true,
        subRoutes: [
            {
                path: "/rechargeHistory/recharge-history",
                name: "Recharge",
                icon: <BiUser color="#768191" />,
            },
            {
                path: "/rechargeHistory/dth-history",
                name: "DTH",
                icon: <BiUser color="#768191" />,
            },
            {
                path: "/rechargeHistory/gas-history",
                name: "GAS",
                icon: <BiUser color="#768191" />,
            },
            {
                path: "/rechargeHistory/fastag-history",
                name: "FASTAG",
                icon: <BiUser color="#768191" />,
            },
            {
                path: "/rechargeHistory/electricity-history",
                name: "ELECTRICITY",
                icon: <BiUser color="#768191" />,
            },
        ],
    },
    {
        path: "/skill",
        name: "Skill",
        icon: <BiAbacus color="#768191" />,
    },
    {
        path: "/remedies",
        name: "Remedies",
        icon: <BiAbacus color="#768191" />,
    },
    {
        path: "/main-expertise",
        name: "Main Expertise",
        icon: <BiAbacus color="#768191" />,
    },
    {
        path: "/language",
        name: "Language",
        icon: <BiAbacus color="#768191" />,
    },
    {
        path: "/banner",
        name: "Banner",
        icon: <PiFlagBanner color="#768191" />,
    },
    {
        path: "/category",
        name: "Category",
        icon: <MdCategory color="#768191" />,
    },
    {
        path: "/sub-category",
        name: "Sub Category",
        icon: <TbCategoryPlus color="#768191" />,
    },
    {
        name: "Yatra",
        icon: <MdOutlineModeOfTravel color="#768191" />,
        subRoutes: [
            {
                path: "/yatra",
                name: "Yatra",
                icon: <AiOutlineBug color="#768191" />
            },
            {
                path: "/yatra-child-categories",
                name: "Yatra Child Categories",
                icon: <CgShoppingCart color="#FF5722" />,
            },
            {
                path: "/yatraHistory",
                name: "Yatra History",
                icon:  <AiOutlineBug color="#768191" />
            }
        ],
    },
    {
        name: "Sanchar",
        icon: <GiNewspaper color="#768191" />,
        subRoutes: [
            {
                path: "/podcast",
                name: "Podcast",
                icon: <AiOutlineBug color="#768191" />
            },
            {
                path: "/video-clip",
                name: "Videoclip",
                icon: <AiOutlineBug color="#768191" />
            },
            {
                path: "/news",
                name: "News",
                icon: <AiOutlineBug color="#768191" />
            },
            {
                path: "/live",
                name: "Live",
                icon: <AiOutlineBug color="#768191" />
            },
            {
                path: "/spl-live",
                name: "SPL Live",
                icon: <AiOutlineBug color="#FF4500" />
            },
        ],
    },
    {
        name: "Religious",
        icon: <MdOutlineModeOfTravel color="#768191" />,
        subRoutes: [
            {
                path: "/religious/daily-darshan",
                name: "Daily Darshan",
                icon: <AiOutlineBug color="#768191" />
            },
            {
                path: "/all_consultant_requests",
                name: "Consultant Requests",
                 icon: <AiOutlineBug color="#768191" />
            }
        ],
    },
    {
        name: "Ecommerce",
        icon: <CgShoppingCart color="#768191" />,
        subRoutes: [
            {
                path: "/e-commerce/category",
                name: "Category",
                icon: <AiOutlineBug color="#768191" />,
            },
            {
                path: "/e-commerce/sub-category",
                name: "Sub Category",
                icon: <AiOutlineBug color="#768191" />,
            },
            {
                path: "/e-commerce/attribute",
                name: "Attribute",
                icon: <AiOutlineBug color="#768191" />,
            },
            {
                path: "/e-commerce/product",
                name: "Product",
                icon: <AiOutlineBug color="#768191" />,
            },
        ],
    },
    {
        name: "TBO Bookings",
        icon: <MdOutlineModeOfTravel color="#768191" />,
        subRoutes: [
            {
                path: "/tbo/settings",
                name: "TBO Settings",
                icon: <AiOutlineBug color="#768191" />,
            },
            {
                path: "/tbo/flight-bookings",
                name: "Flight Bookings",
                icon: <AiOutlineBug color="#768191" />,
            },
            {
                path: "/tbo/hotel-bookings",
                name: "Hotel Bookings",
                icon: <AiOutlineBug color="#768191" />,
            },
        ],
    },
    {
        name: "Milan Sathi",
        icon: <BiUser color="#768191" />,
        subRoutes: [
            {
                path: "/milan-sathi",
                name: "Dashboard",
                icon: <LuLayoutDashboard color="#768191" />,
            },
            {
                path: "/milan-sathi/users",
                name: "Users",
                icon: <BiUser color="#768191" />,
            },
            {
                path: "/milan-sathi/verifications",
                name: "Verifications",
                icon: <AiOutlineBug color="#768191" />,
            },
            {
                path: "/milan-sathi/plans",
                name: "Plans",
                icon: <BiAbacus color="#768191" />,
            },
            {
                path: "/milan-sathi/transactions",
                name: "Transactions",
                icon: <MdPersonPin color="#768191" />,
            },
            {
                path: "/milan-sathi/name-verification",
                name: "Name Verification",
                icon: <MdVerifiedUser color="#768191" />,
            },
            {
                path: "/milan-sathi/create-profile",
                name: "Create Profile",
                icon: <BiUser color="#E91E63" />,
            },
        ],
    },    {
        name: "Astrologer Admin",
        icon: <FaStar color="#9C27B0" />,
        subRoutes: [
            {
                path: "/astrologer-admin/kyc",
                name: "KYC Approvals",
                icon: <MdVerifiedUser color="#9C27B0" />,
            },
            {
                path: "/astrologer-admin/consultations",
                name: "Consultations",
                icon: <MdChat color="#9C27B0" />,
            },
            {
                path: "/astrologer-admin/payouts",
                name: "Payouts",
                icon: <MdAccountBalance color="#9C27B0" />,
            },
            {
                path: "/astrologer-admin/ratings",
                name: "Ratings & Reviews",
                icon: <MdStar color="#9C27B0" />,
            },
        ],
    },

    {
        path: "/post-banao",
        name: "Post Banao",
        icon: <MdCategory color="#768191" />,
    },
    {
        name: "Rojgar",
        icon: <MdCategory color="#FF5722" />,
        subRoutes: [
            {
                path: "/rojgar/dashboard",
                name: "Dashboard",
                icon: <BiAbacus color="#FF5722" />,
            },
            {
                path: "/rojgar/seekers",
                name: "Job Seekers",
                icon: <MdPersonPin color="#FF5722" />,
            },
            {
                path: "/rojgar/provider-kyc",
                name: "Provider KYC",
                icon: <MdVerifiedUser color="#FF5722" />,
            },
            {
                path: "/rojgar/job-moderation",
                name: "Job Moderation",
                icon: <AiOutlineBug color="#FF5722" />,
            },
            {
                path: "/rojgar/management",
                name: "Categories & Plans",
                icon: <MdCategory color="#FF5722" />,
            },
        ],
    },
    {
        name: "Vendor Management",
        icon: <BiUser color="#FF6B00" />,
        subRoutes: [
            {
                path: "/vendor-management/all",
                name: "All Vendors",
                icon: <BiUser color="#FF6B00" />,
            },
            {
                path: "/vendor-management/pending",
                name: "Pending Approvals",
                icon: <MdVerifiedUser color="#FF9800" />,
            },
            {
                path: "/vendor-management/sanatani-commission",
                name: "SS Commission",
                icon: <MdAccountBalance color="#795548" />,
            },
            {
                path: "/vendor-management/sanatani-settlements",
                name: "SS Settlements",
                icon: <MdAccountBalance color="#795548" />,
            },
        ],
    },
    {
        name: "Marketplace",
        icon: <CgShoppingCart color="#4CAF50" />,
        subRoutes: [
            {
                path: "/marketplace/dashboard",
                name: "Dashboard",
                icon: <LuLayoutDashboard color="#4CAF50" />,
            },
            {
                path: "/marketplace/products",
                name: "Product Approvals",
                icon: <AiOutlineBug color="#4CAF50" />,
            },
            {
                path: "/marketplace/orders",
                name: "Orders",
                icon: <CgShoppingCart color="#4CAF50" />,
            },
            {
                path: "/marketplace/commission",
                name: "Commission Rules",
                icon: <BiAbacus color="#4CAF50" />,
            },
            {
                path: "/marketplace/categories",
                name: "Categories",
                icon: <CgShoppingCart color="#4CAF50" />,
            },
            {
                path: "/marketplace/settlements",
                name: "Settlements",
                icon: <MdAccountBalance color="#4CAF50" />,
            },
        ],
    },
    {
        path: "/all-transactions",
        name: "All Transactions",
        icon: <MdPersonPin color="#4CAF50" />,
    },
    {
        path: "/fraud-blocks",
        name: "Fraud Blocks",
        icon: <MdPersonPin color="#f44336" />,
        hidden: true,
    },
    {
        path: "/transaction",
        name: "Transaction",
        icon: <MdPersonPin color="#768191" />,
        hidden: true,
    },
    {
        path: "/operator-images",
        name: "Operator Images",
        icon: <MdPersonPin color="#768191" />,
        hidden: true,
    },
    {
        path: '/flight-images',
        name: "Flight Images",
        icon: <MdPersonPin color="#768191" />,
        hidden: true,
    },    {
        name: "Sanatani Manch",
        icon: <MdCategory color="#FF9800" />,
        subRoutes: [
            {
                path: "/sanatani-manch/dashboard",
                name: "Dashboard",
                icon: <LuLayoutDashboard color="#FF9800" />,
            },
            {
                path: "/sanatani-manch/service-plans",
                name: "Service Plans",
                icon: <BiAbacus color="#FF9800" />,
            },
            {
                path: "/sanatani-manch/purchases",
                name: "Purchase History",
                icon: <MdPersonPin color="#FF9800" />,
            },
            {
                path: "/sanatani-manch/users",
                name: "Users",
                icon: <BiUser color="#FF9800" />,
            },
            {
                path: "/sanatani-manch/posts",
                name: "Posts",
                icon: <AiOutlineBug color="#FF9800" />,
            },
            {
                path: "/sanatani-manch/categories",
                name: "Categories",
                icon: <MdCategory color="#FF9800" />,
            },
            {
                path: "/sanatani-manch/events",
                name: "Events",
                icon: <BiAbacus color="#FF9800" />,
            },
            {
                path: "/sanatani-manch/flags",
                name: "Flags & Reports",
                icon: <PiFlagBanner color="#FF9800" />,
            },
            {
                path: "/sanatani-manch/banned-names",
                name: "Banned Names",
                icon: <MdBlock color="#FF9800" />,
            },
        ],
    },

    {
        name: "Sanatani Sadan",
        icon: <MdOutlineHotel color="#795548" />,
        subRoutes: [
            {
                path: "/sanatani-sadan/partners",
                name: "Hotel Partners",
                icon: <BiUser color="#795548" />,
            },
            {
                path: "/sanatani-sadan/properties",
                name: "Properties",
                icon: <MdOutlineHotel color="#795548" />,
            },
            {
                path: "/sanatani-sadan/bookings",
                name: "Bookings",
                icon: <AiOutlineCalendar color="#795548" />,
            },
            {
                path: "/sanatani-sadan/analytics",
                name: "Analytics",
                icon: <AiOutlineBarChart color="#795548" />,
            },
            {
                path: "/sanatani-sadan/locations",
                name: "Locations",
                icon: <MdOutlineHotel color="#795548" />,
            },
            {
                path: "/vendor-agreements",
                name: "Vendor Agreements",
                icon: <PiUserGearLight color="#FF6B00" />,
            },
        ],
    },
    {
        name: "Grow",
        icon: <span style={{fontSize:"20px"}}>🌱</span>,
        hidden: true,
        subRoutes: [
            {
                path: "/grow/categories",
                name: "Categories",
                icon: <MdCategory color="#4CAF50" />,
            },
            {
                path: "/grow/services",
                name: "Services",
                icon: <CgShoppingCart color="#4CAF50" />,
            },
            {
                path: "/grow/purchases",
                name: "Purchase History",
                icon: <BsListCheck color="#4CAF50" />,
            },
        ],
    },

    {
        name: "Roles & Logs",
        icon: <PiUserGearLight color="#673AB7" />,
        subRoutes: [
            {
                path: "/roles",
                name: "Role Management",
                icon: <PiUserGearLight color="#673AB7" />,
            },
            {
                path: "/sub-admin",
                name: "Sub Admins",
                icon: <BiUser color="#673AB7" />,
            },
            {
                path: "/activity-logs",
                name: "Activity Logs",
                icon: <AiOutlineBug color="#673AB7" />,
            },
        ],
    },
    {
        name: "Static Pages",
        icon: <FaRegNewspaper color="#768191" />,
        subRoutes: [
            {
                path: "/about-us",
                name: "About Us",
                icon: <FaRegNewspaper color="#768191" />,
            },
            {
                path: "/terms-and-conditions",
                name: "Terms & Conditions",
                icon: <FaRegNewspaper color="#768191" />,
            },
            {
                path: "/privacy-policies",
                name: "Privacy Policies",
                icon: <FaRegNewspaper color="#768191" />,
            },
            {
                path: "/refund-policies",
                name: "Refund Policies",
                icon: <FaRegNewspaper color="#768191" />,
            }
        ],
    },

    {
        path: "/home-sections",
        name: "Home Sections",
        icon: <span style={{fontSize:"20px"}}>🏠</span>,
    },
    {
        name: "Issue Control",
        icon: <MdBugReport color="#E91E63" />,
        subRoutes: [
            {
                path: "/issues/dashboard",
                name: "Dashboard",
                icon: <LuLayoutDashboard color="#E91E63" />,
            },
            {
                path: "/issues",
                name: "All Issues",
                icon: <BsListCheck color="#E91E63" />,
            },
            {
                path: "/issues/create",
                name: "Create Issue",
                icon: <AiOutlineBug color="#E91E63" />,
            },
        ],
    },
];